<script setup lang="ts">
import { useLocale } from '@/plugins/translation';
import { computed } from 'vue';
import { useDisplay } from 'vuetify';
import { stopAllSounds } from '@ilteducation/audio-resources';
import useQuizStore from '@/store/quiz';
import { storeToRefs } from 'pinia';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const { t, l } = useLocale();
const { xs } = useDisplay();
const quizStore = useQuizStore();
const { mode, isLoading, currentQuiz, currentQuestion } = storeToRefs(quizStore);

const totalQuestions = computed(() => currentQuiz.value?.content.length || 0);

const backButtonAvailability = computed(() => currentQuestion.value === 1);
const lastQuestion = computed(() => currentQuestion.value === totalQuestions.value);

const nextQuestion = () => {
  stopAllSounds();
  quizStore.nextQuestion();
};
const prevQuestion = () => {
  stopAllSounds();
  quizStore.prevQuestion();
};
const correctQuiz = () => {
  stopAllSounds();
  quizStore.setGradingStatus();
  quizStore.compareAnswers();
};
</script>
<template>
  <div v-if="mode === 'quiz' && xs" class="pb-4">
    <p class="progress-text">{{ t(l.quiz.quiz_progress, { current: currentQuestion, last: totalQuestions }) }}</p>
  </div>
  <div class="quiz-navigation-container d-flex align-center justify-space-between ga-7">
    <div v-if="mode === 'quiz' && !xs" class="pl-0">
      <p class="progress-text">{{ t(l.quiz.quiz_progress, { current: currentQuestion, last: totalQuestions }) }}</p>
    </div>
    <div class="d-flex ga-4">
      <v-btn
        class="text-none nav-btn nav-btn--back"
        :disabled="backButtonAvailability"
        variant="outlined"
        @click="prevQuestion"
      >
        <FontAwesomeIcon class="mr-1" icon="fa-solid fa-chevron-left" />
        {{ t(l.quiz.back) }}
      </v-btn>
      <v-btn
        v-if="currentQuestion !== totalQuestions"
        :disabled="!quizStore.questionHasAnswer"
        class="text-none nav-btn nav-btn--next"
        variant="flat"
        @click="nextQuestion"
      >
        {{ t(l.quiz.next) }}
        <FontAwesomeIcon class="ml-1" icon="fa-solid fa-chevron-right" />
      </v-btn>
      <v-btn
        v-if="lastQuestion"
        class="text-none nav-btn nav-btn--next"
        :disabled="!quizStore.questionHasAnswer || isLoading"
        variant="flat"
        @click="correctQuiz"
      >
        {{ t(l.quiz.show_result) }}
        <FontAwesomeIcon class="ml-1" icon="fa-solid fa-chevron-right" />
      </v-btn>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.quiz-navigation-container {
  width: 100%;
}

.progress-text {
  font-size: 18px;
  line-height: 24px;
  color: rgb(var(--v-theme-on-surface));
  margin: 0;
}

.nav-btn {
  min-height: 48px;
  height: 48px;
  border-radius: 8px;
  font-size: 14px;
  padding: 4px 16px;

  &--back {
    color: rgb(var(--v-theme-primary)) !important;
    border: 1px solid rgb(var(--v-theme-outline));
    background-color: transparent !important;
  }

  &--next {
    color: rgb(var(--v-theme-on-secondary-container)) !important;
    background-color: rgb(var(--v-theme-secondary-container)) !important;
  }
}
</style>
